import { Leaf, Cpu, Award, Fingerprint } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const PILLARS = [
  { icon: Leaf, title: "Cosmesi 100% biologica", text: "Solo linee certificate, formulate con attivi vegetali ad alta concentrazione. Niente siliconi, parabeni o profumi sintetici: la tua pelle riconosce la differenza." },
  { icon: Cpu, title: "Tecnologie di ultima generazione", text: "Laser progressivo permanente e strumenti professionali costantemente aggiornati, per trattamenti sicuri, rapidi ed efficaci su ogni tipo di pelle." },
  { icon: Award, title: "Operatrice specializzata", text: "" },
  { icon: Fingerprint, title: "Percorsi su misura", text: "Nessun protocollo standard: ogni trattamento nasce da una consulenza personalizzata e viene adattato ai tuoi obiettivi, ai tuoi tempi, alla tua pelle." },
];

export const WhyUs = () => (
  <section id="perche-biovital" className="relative overflow-hidden bg-sage-dark py-24 text-cream md:py-36 grain" data-testid="why-us-section">
    <div className="pointer-events-none absolute -right-40 -top-40 h-[32rem] w-[32rem] rounded-full bg-sage/40 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-32 -left-24 h-96 w-96 rounded-full bg-gold/10 blur-3xl" />
    <div className="container-x relative">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <SectionHeading
            id="whyus"
            light
            eyebrow="Perché Scegliere Biovital"
            title={<>Quattro promesse, <em className="font-normal italic text-gold-light">una sola</em> filosofia.</>}
            subtitle="Non vendiamo miracoli. Offriamo costanza, competenza e prodotti in cui crediamo davvero — in un ambiente dove il tempo torna ad essere tuo."
          />
          <Reveal delay={0.3} className="mt-12 hidden lg:block">
            <div className="font-serif text-[9rem] leading-none text-cream/5 select-none">Bio</div>
          </Reveal>
        </div>
        <div className="grid gap-px overflow-hidden rounded-[2rem] border border-cream/10 bg-cream/10 sm:grid-cols-2 lg:col-span-7">
          {PILLARS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1} className="h-full">
              <div className="group relative flex h-full flex-col bg-sage-dark p-8 transition-colors duration-500 hover:bg-sage md:p-10" data-testid={`pillar-${i}`}>
                <span className="font-serif text-sm tracking-widest text-gold-light">0{i + 1}</span>
                <span className="mt-6 flex h-12 w-12 items-center justify-center rounded-full border border-gold/40 text-gold-light transition-[background-color,color] duration-500 group-hover:bg-gold group-hover:text-white">
                  <p.icon className="h-5 w-5" />
                </span>
                <h3 className="mt-6 font-serif text-2xl leading-tight">{p.title}</h3>
                {p.text && <p className="mt-3 text-sm leading-relaxed text-cream/65">{p.text}</p>}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
